'use client';
import Link from 'next/link';
import { cn } from '@/lib/utils';
import classes from './whyHisea.module.css';

export const WhyHisea = () => {
  const list = [
    {
      name: 'Waterproof Guarantee',
      src: `Water`,
    },
    {
      name: 'Comfort & Durability',
      src: `Comfort`,
    },
    {
      name: 'Free Shipping & Returns',
      src: `Free`,
      href: '/shipping-return-policy',
    },
    {
      name: 'Lifetime Warranty',
      src: `Lifetime`,
      href: '/warranty',
    },
    {
      name: 'More About Hisea',
      src: `More`,
      href: '/about-us',
    },
  ];

  return (
    <div className={cn('mx-auto max-w-site', classes.whyHiseaBox)}>
      <h2 className={cn('mb-2 font-teko-medium text-[40px] font-medium uppercase', classes.title)}>
        Why Choose Hisea?
      </h2>
      <div className='w-full'>
        {list.map((item, index) => (
          <Item
            item={item}
            key={index}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

function Item({ item, index }) {
  // 原本是 <div onClick={() => (window.location.href = item.href)}>：对 Google 来说不是
  // 链接，/shipping-return-policy、/warranty、/about-us 因此拿不到首页内链。
  // 有 href 的渲染成真正的 <Link>，没有 href 的保持 <div>。
  const Wrapper = item.href ? Link : 'div';
  const wrapperProps = item.href ? { href: item.href } : {};

  return (
    <Wrapper
      {...wrapperProps}
      className={cn('inline-block overflow-hidden py-5 text-center', item.href ? 'cursor-pointer' : '', classes.item)}
    >
      <div
        className={cn(
          'mx-auto mb-2 overflow-hidden bg-100 bg-center bg-no-repeat',
          classes.animateBackInDown,
          classes.icon,
        )}
        style={{
          backgroundImage: `url(/home/whyHisea/${item.src}.png)`,
        }}
      />
      <h3 className={cn('font-roboto-medium text-[16px] lg_text-[20px]', item.href ? classes.decorationAni : '')}>
        {item.name}
      </h3>
    </Wrapper>
  );
}

export default WhyHisea;
